<template>
  <div class="content hasPadding livePreview">
    <timeline>
      <timeline-item v-for="(item, index) in advanceList" :key="index">
        <div @click="goLive(item)">
          <p class="time">
            {{ item.ifToday }} {{ times(item.ifToday, item.liveStartTime) }}
          </p>
          <div class="box">
            <div class="doc_info">
              <img class="photo" :src="item.headPhoto" alt="" />
              <div class="right">
                <p>
                  <span class="doc_name">{{ item.userName }}</span>
                  <span>{{ item.duties }}</span>
                </p>
                <p class="right_hos">{{ item.hospitalName }}</p>
              </div>
              <div class="live fontLive fontLiveActive" v-if="item.ifNow == 1">
                立即进入
              </div>
              <!-- <img
                class="live"
                v-if="item.ifNow == 1"
                src="http://cdn.yxvzb.com/newWechat/image/liveIcon_03.png"
              /> -->
              <!--<div class="live fontLive" v-else-if="item.ifNow==2">已报名</div>-->
              <div
                class="live fontLive fontLiveActive"
                v-else
                @click.stop="signUp(item)"
              >
                立即报名
              </div>
            </div>
            <h5 class="centent">{{ item.courseName }}</h5>
          </div>
        </div>
      </timeline-item>
      <!--<p style="text-align:center;margin-top: 1rem" v-show="!advanceList.length ">-->
      <!--<inline-loading></inline-loading><span style="vertical-align:middle;display:inline-block;font-size:14px;">&nbsp;&nbsp;加载中</span>-->
      <!--</p>-->
    </timeline>
  </div>
</template>

<script>
// TODO: vux
import { Timeline, TimelineItem, XButton, dateFormat } from 'vux';

//  import LiveItem from './components/item.vue'
import { live } from '@/api/ajax';
export default {
  components: {
    Timeline,
    TimelineItem,
    XButton
  },
  data() {
    return {
      advanceList: [],
      ifToday: '',
      weekList: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      ifNow: '' //1.直播中 2.已报名 3.未报名
    };
  },
  methods: {
    goLive(item) {
      let wxUserInfoObj = this.$api.getStorage('wxUserInfo');
      sa.track(
        'liveItem_click',
        {
          pageUrl: location.href,
          liveClassId: item.id,
          liveClassName: item.courseName,
          client_id: wxUserInfoObj.id || wxUserInfoObj.wxOpenId,
          web_edition: 2
        },
        function() {}
      );
      this.$router.push({ name: 'liveDetail', params: { id: item.id } });
    },
    signUp(item) {
      live.wxCourseBook({ id: item.id, courseId: item.id }).then(res => {
        if (res.data.stauts == '1') {
          this.$set(item, 'ifNow', 2);
          this.$vux.toast.show({
            type: 'text',
            position: 'top',
            text: '报名成功'
          });
        }
      });
    },
    format(list) {
      list.filter((item, index) => {
        let nowYear = new Date().getFullYear(),
          year = new Date(item.liveStartTime).getFullYear(),
          nowMonth = new Date().getMonth(),
          month = new Date(item.liveStartTime).getMonth(),
          nowDay = new Date().getDate(),
          day = new Date(item.liveStartTime).getDate(),
          timeStamp = new Date(year, month, day).getTime();
        if (nowMonth == month && day == nowDay) {
          this.$set(item, 'ifToday', '今天');
        } else if (
          timeStamp - new Date().getTime() < 1000 * 60 * 60 * 24 &&
          timeStamp - new Date().getTime() > 0
        ) {
          this.$set(item, 'ifToday', '明天');
        } else {
          let index = new Date(item.liveStartTime).getDay();
          this.$set(item, 'ifToday', this.weekList[index]);
        }
        if (item.liveStartTime < new Date().getTime()) {
          this.$set(item, 'ifNow', 1);
        } else {
          if (item.hasSignUp == '0') {
            this.$set(item, 'ifNow', 3);
          } else {
            this.$set(item, 'ifNow', 2);
          }
        }
      });
    },
    times(type, input) {
      if (type == '今天' || type == '明天') {
        return dateFormat(input, 'HH:mm');
      } else {
        var month = new Date(input).getMonth() + 1,
          day = new Date(input).getDate(),
          month = month < 10 ? '0' + month : month;
        var day = day < 10 ? '0' + day : day;
        var hour =
          new Date(input).getHours() < 10
            ? '0' + new Date(input).getHours()
            : new Date(input).getHours();
        var min =
          new Date(input).getMinutes() < 10
            ? '0' + new Date(input).getMinutes()
            : new Date(input).getMinutes();
        return month + '月' + day + '日' + hour + ':' + min;
      }
    }
  },
  created() {
    live.advance().then(res => {
      this.advanceList = res.data.data;
      this.format(this.advanceList);
    });
  },
  filters: {
    //        times:function(val){
    //            return dateFormat(val,'HH:mm')
    //        }
  }
};
</script>
<style lang="less">
.livePreview {
  .weui-icon-success-no-circle {
    display: none !important;
  }
  .vux-timeline-item-head-first {
    width: 10px !important;
    height: 10px !important;
    left: 1px !important;
    top: 4px !important;
  }
  .vux-timeline-item-color {
    background-color: #027cfa !important;
  }
  .vux-timeline-item-tail {
    background-color: #027cfa !important;
  }
  .vux-timeline-item-content {
    padding: 0 0 0.56rem 0.85rem;
  }
}
</style>
<style lang="less" scoped>
.vux-timeline {
  padding: 0;
}
.content {
  padding: 0.4rem 0.533rem;
  .vux-timeline-item-head-first {
    width: 10px;
    height: 10px;
  }
}

.time {
  font-size: 0.3733rem;
  color: #027cfa;
}
.box {
  width: 8rem;
  box-shadow: 0 0 0.266rem 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin-top: 0.18rem;
  padding: 0.4rem 0.2666rem;
  .doc_info {
    position: relative;
    display: flex;
    align-items: center;
    .photo {
      width: 0.9066rem;
      height: 0.9066rem;
      display: block;
      border-radius: 50%;
      border: 1px solid #027cfa;
      margin-right: 0.24rem;
    }
    .live {
      width: 0.96rem;
      height: 0.4rem;
      position: absolute;
      right: 0;
      top: 0.12rem;
    }
    .fontLive {
      width: 1.44rem;
      height: 0.587rem;
      line-height: 0.587rem;
      text-align: center;
      font-size: 0.32rem;
      color: #fff;
      background: #d8d8d8;
      border-radius: 0.08rem;
    }
    .fontLiveActive {
      background-image: linear-gradient(-90deg, #2eacfd 0%, #027cfa 100%);
    }
    .right {
      width: 6.5rem;
      .doc_name {
        font-size: 0.3733rem;
        font-weight: bold;
        margin-right: 0.133rem;
      }
    }
    .right_hos {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .centent {
    margin-top: 0.2666rem;
    font-size: 0.3733rem;
    line-height: 1.3;
  }
  .sign {
    border-radius: 0.08rem;
    width: 1.44rem;
    height: 0.5866rem;
    position: absolute;
    right: 0;
    text-align: center;
    line-height: 0.5866rem;
  }
  .isSign {
    background-image: linear-gradient(-90deg, #027cfa 0%, #2eacfd 100%);
    color: #fff;
  }
}
</style>
